export const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const calculateRemainingTimeUntilMidnight = (): number => {
  const now = new Date();
  const tomorrow = new Date(now);
  tomorrow.setHours(24, 0, 0, 0); // 다음 날 자정 설정

  return Math.floor((tomorrow.getTime() - now.getTime()) / 1000);
};
